import 'firebase/auth';
import { messagedCall, post } from '.';
import firebase from '../firebase';

export const login = async (email: string, password: string) =>
  messagedCall(
    firebase.auth().signInWithEmailAndPassword(email, password),
    'loginLoading',
    'loginSuccess',
    'loginFailed'
  );

export const forgotPassword = async (email: string) =>
  messagedCall(
    firebase.auth().sendPasswordResetEmail(email),
    'forgotPasswordLoading',
    'forgotPasswordSuccess',
    'forgotPasswordFailed'
  );

export const logout = () => messagedCall(firebase.auth().signOut(), 'logoutLoading', 'logoutSuccess', 'logoutSuccess');

export const updateAdmin = async (isAdmin: boolean, uid?: string, email?: string) => {
  return post('updateAdmin', { isAdmin, uid, email });
};

export const updateEmailAdmin = async (newEmail: string, uid?: string, email?: string) => {
  return messagedCall(post('updateEmail', { uid, email, newEmail }), 'updating', 'success', 'failed');
};

export const updateEmail = async (newEmail: string) => {
  messagedCall(firebase.auth().currentUser.updateEmail(newEmail), 'updating', 'success', 'failed');
};

export const updatePassword = async (newPassword: string) => {
  messagedCall(firebase.auth().currentUser.updatePassword(newPassword), 'updating', 'success', 'failed');
};

export const isLoggedIn = (): boolean => firebase.auth().currentUser != null;

export const getCurrentEmail = (): string => (isLoggedIn() ? firebase.auth().currentUser.email : '');

export const isAdmin = async (): Promise<boolean> => {
  if (!isLoggedIn()) return false;
  try {
    const result = await firebase.auth().currentUser.getIdTokenResult();
    return !!result.claims?.admin;
  } catch (err) {
    return false;
  }
};
